var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.0103H5.00001V18.6603C3.0936 17.5596 1.60363 15.8606 0.761214 13.8268C-0.0812036 11.7931 -0.229007 9.53815 0.340742 7.41181C0.910492 5.28548 2.16596 3.40656 3.9124 2.06647C5.65884 0.726375 7.79867 0 10 0C12.2014 0 14.3412 0.726375 16.0876 2.06647C17.8341 3.40656 19.0895 5.28548 19.6593 7.41181C20.229 9.53815 20.0812 11.7931 19.2388 13.8268C18.3964 15.8606 16.9064 17.5596 15 18.6603V19.0103ZM7.00001 19.0103H13V17.4503L13.55 17.1703C15.1664 16.3685 16.4643 15.0438 17.2329 13.4113C18.0015 11.7789 18.1957 9.93457 17.7839 8.17785C17.3722 6.42113 16.3786 4.8552 14.9646 3.73434C13.5507 2.61348 11.7993 2.00352 9.99501 2.00352C8.19068 2.00352 6.43933 2.61348 5.02537 3.73434C3.61141 4.8552 2.61786 6.42113 2.2061 8.17785C1.79433 9.93457 1.98852 11.7789 2.75712 13.4113C3.52573 15.0438 4.82362 16.3685 6.44002 17.1703L7.00001 17.4503V19.0103Z",
    fill: "url(#paint0_linear_3151_4994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9902 16H8.99023V24H10.9902V16Z",
    fill: "url(#paint1_linear_3151_4994)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.0103H5.00001V18.6603C3.0936 17.5596 1.60363 15.8606 0.761214 13.8268C-0.0812036 11.7931 -0.229007 9.53815 0.340742 7.41181C0.910492 5.28548 2.16596 3.40656 3.9124 2.06647C5.65884 0.726375 7.79867 0 10 0C12.2014 0 14.3412 0.726375 16.0876 2.06647C17.8341 3.40656 19.0895 5.28548 19.6593 7.41181C20.229 9.53815 20.0812 11.7931 19.2388 13.8268C18.3964 15.8606 16.9064 17.5596 15 18.6603V19.0103ZM7.00001 19.0103H13V17.4503L13.55 17.1703C15.1664 16.3685 16.4643 15.0438 17.2329 13.4113C18.0015 11.7789 18.1957 9.93457 17.7839 8.17785C17.3722 6.42113 16.3786 4.8552 14.9646 3.73434C13.5507 2.61348 11.7993 2.00352 9.99501 2.00352C8.19068 2.00352 6.43933 2.61348 5.02537 3.73434C3.61141 4.8552 2.61786 6.42113 2.2061 8.17785C1.79433 9.93457 1.98852 11.7789 2.75712 13.4113C3.52573 15.0438 4.82362 16.3685 6.44002 17.1703L7.00001 17.4503V19.0103Z",
    fill: "url(#paint2_linear_3151_4994)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9902 16H8.99023V24H10.9902V16Z",
    fill: "url(#paint3_linear_3151_4994)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4994",
    x1: 10,
    y1: 20.7705,
    x2: 10,
    y2: -2.46429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3151_4994",
    x1: 9.99023,
    y1: 24.7407,
    x2: 9.99023,
    y2: 14.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3151_4994",
    x1: 10,
    y1: 20.7705,
    x2: 10,
    y2: -2.46429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3151_4994",
    x1: 9.99023,
    y1: 24.7407,
    x2: 9.99023,
    y2: 14.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2177,
    stopColor: "#5C2562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656429,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91B5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutActive);
export default __webpack_public_path__ + "static/media/logout-active.6c934df28278549e62309587863e433f.svg";
export { ForwardRef as ReactComponent };